import { useQuery } from '@tanstack/react-query';
import { getActiveMembers, getArchivedMembers } from 'utils/api/member';

export const useActiveMembers = (enabled = true) => {
  return useQuery({
    queryKey: ['active-members'],
    queryFn: () => getActiveMembers(),
    select: (data) => data.data,
    enabled,
  });
};

export const useArchivedMembers = (enabled = true) => {
  return useQuery({
    queryKey: ['archived-members'],
    queryFn: () => getArchivedMembers(),
    select: (data) => data.data,
    enabled,
  });
};
